import {useSelector} from 'react-redux';
import {appointmentBooksState} from '../../../../../../store/reducers/appointments';
import {useSessionStyles} from '../useSessionStyles';
import AttendanceChip from '../../../../../../components/notes/component/attendanceChip';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';
import {memo, useCallback} from 'react';
import {mapHospitalList, wardsList} from '../../../../../../store/reducers/ward';

const AppointmentSelectedAttendance = () => {
    const classes = useSessionStyles();
    const {t} = useTranslation();

    // Selectors
    const bookState = useSelector(appointmentBooksState);
    const hospitalList = useSelector(mapHospitalList);
    const wardList = useSelector(wardsList);

    const getHospital = useCallback(() => {
        if (bookState?.linkedAttendance?.facility) {
            const id = bookState?.linkedAttendance?.facility;
            const find = hospitalList.find(e => e?.__id === id);
            return find?.description || '';
        }
        return '';
    }, [bookState?.linkedAttendance, hospitalList]);

    const getLocation = useCallback(() => {
        if (bookState?.linkedAttendance?.pointOfCare) {
            const id = bookState?.linkedAttendance?.pointOfCare;
            const find = wardList.find(e => e?.wardsId?.[0] === id);
            return find?.name || bookState?.linkedAttendance?.pointOfCare;
        }
        return bookState?.linkedAttendance?.attendanceType === 'E' ? 'ED' : 'Unknown';
    }, [bookState?.linkedAttendance, wardList]);

    if (!bookState?.linkedAttendance) {
        return (
            <Typography variant="body2" color="textSecondary" style={{marginLeft: 10}}>
                {t('Appointment not linked to any activity')}
            </Typography>
        )
    };

    return (
        <div className={classes.selectedAttendanceBox}>
            <div className={classes.selectedAttendanceBoxLine}>
                <AttendanceChip admission={bookState?.linkedAttendance} classesOverride={classes.chipBackground}/>

                <Typography variant="body2">
                    {getHospital()}
                </Typography>
            </div>
            <div className={classes.selectedAttendanceBoxLine}>
                <Typography fontWeight={500} variant="body1">
                    {t('Visit number')} {bookState?.linkedAttendance?.attendanceId || 'Unknown'}
                </Typography>

                <Typography fontWeight={500} variant="body1">
                    {t('Location')} {getLocation()}
                </Typography>
            </div>
        </div>
    );
};

export default memo(AppointmentSelectedAttendance);